import { getKnowledgeList, getKLByProblemGuid } from '@/api/api_knowledge'

const state = {
  knowledgeData: []
}

const mutations = {
  SET_KNOWLEDGE_DATA: (state, data) => {
    state.knowledgeData = data
  }
}

const actions = {
  actions_getKnowledgeList ({ commit }, keywords) {
    console.log('-------actions_getKnowledgeList-------')
    return new Promise((resolve, reject) => {
      getKnowledgeList(keywords).then(response => {
        const data = response.data
        if (data.isOk) {
          commit('SET_KNOWLEDGE_DATA', data.data)
          resolve()
        } else {
          reject(data.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  actions_getKLByProblemGuid ({ commit }, tmguid) {
    console.log('-------actions_getKnowledgeList-------tmguid=' + tmguid)
    return new Promise((resolve, reject) => {
      getKLByProblemGuid(tmguid).then(response => {
        const data = response.data
        if (data.isOk) {
          commit('SET_KNOWLEDGE_DATA', data.data)
          resolve()
        } else {
          reject(data.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const getters = {
  knowledgeList: state => state.knowledgeData
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/knowledgeListData.js